<template>
	<CDropdown inNav class="c-header-nav-items" placement="bottom-end" add-menu-classes="pt-0">
		<template #toggler>
			<CHeaderNavLink>
				<div class="c-avatar">
					<img src="img/avatars/avatar-bo.jpg" class="c-avatar-img" />
				</div>
			</CHeaderNavLink>
		</template>
		<CDropdownHeader tag="div" class="text-center" color="light">
			<strong>Mon compte</strong>
		</CDropdownHeader>
		<!-- <CDropdownItem> <CIcon name="cil-settings" /> Options </CDropdownItem> -->
		<CDropdownItem @click="logout"> <CIcon name="cil-lock-locked" /> Me déconnecter </CDropdownItem>
	</CDropdown>
</template>

<script>
	export default {
		name: 'TheHeaderDropdownAccnt',
		data() {
			return {
				itemsCount: 42,
			};
		},
		methods: {
			logout: function () {
				this.$auth.logout();
			},
		},
	};
</script>

<style scoped>
	.c-icon {
		margin-right: 0.3rem;
	}
</style>
